import { t } from '@ctcells/i18n'

import './feedback.css'

/**
 * 빈 상태. ⚠ 와이어프레임에 대응 요소가 없다 — 내가 정했다(docs/components.md).
 *
 * 🔴 한 줄이다. 「왜 비었는지」 설명을 붙이지 않는다(§1-1). 「N건」 같은 카운트도 금지다.
 *    문구는 `state.empty.*` 키를 쓴다.
 */
export type EmptyStateProps = {
  /** 예: t('state.empty.alarms'). 기본은 '없음' */
  label?: string | undefined
}

export function EmptyState({ label }: EmptyStateProps) {
  return <p className="a-empty">{label ?? t('state.empty.generic')}</p>
}
